// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MRTV","footer":"styles_footer__FklS4","passCodeTooltip":"styles_passCodeTooltip__22P_d"};